import * as React from 'react';
import * as styled from './styled';
import {Title, Description, Preview} from './components';
import {HeaderProps} from './types';

/**
 * The header part of builder component.
 * @param {HeaderProps} props
 * @return {React.ReactElement<HeaderProps>}
 * @constructor
 */
function Header(
    props: HeaderProps,
): React.ReactElement<HeaderProps> {
  return (
    <styled.Wrapper>
      <styled.Side>
        {props.children?.side || (
          <Preview />
        )}
      </styled.Side>
      <styled.Content>
        {props.children?.content || (
          <React.Fragment>
            <Title />
            <Description />
          </React.Fragment>
        )}
      </styled.Content>
    </styled.Wrapper>
  );
}

Header.Title = Title;
Header.Description = Description;
Header.Preview = Preview;

export default Header;
